var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 52,
    viewBox: "0 0 38 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.8217 52H11.1784C5.41505 52 0.713379 47.2983 0.713379 41.535V10.465C0.713379 4.70167 5.41505 0 11.1784 0H26.8217C32.585 0 37.2867 4.70167 37.2867 10.465V41.535C37.2867 47.2983 32.585 52 26.8217 52ZM11.1784 3.40167C7.27838 3.40167 4.11505 6.565 4.11505 10.465V41.535C4.11505 45.435 7.27838 48.5983 11.1784 48.5983H26.8217C30.7217 48.5983 33.885 45.435 33.885 41.535V10.465C33.885 6.565 30.7217 3.40167 26.8217 3.40167H11.1784Z",
    fill: "#0078D7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.3767 13.0649H14.6017C13.67 13.0649 12.89 12.3066 12.89 11.3533C12.89 10.3999 13.6483 9.6416 14.6017 9.6416H23.3767C24.3083 9.6416 25.0883 10.3999 25.0883 11.3533C25.0883 12.3066 24.33 13.0649 23.3767 13.0649Z",
    fill: "#0078D7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19 43.3118C20.6274 43.3118 21.9467 41.9925 21.9467 40.3651C21.9467 38.7377 20.6274 37.4185 19 37.4185C17.3726 37.4185 16.0533 38.7377 16.0533 40.3651C16.0533 41.9925 17.3726 43.3118 19 43.3118Z",
    fill: "#0078D7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.e4aed39b2efd95e814089a3bcbd09e02.svg";
export { ForwardRef as ReactComponent };